import { FC } from "react";
import { BusinessHomeProfile } from "../../../../models/businessHomeProfile";
import { useResponsive } from "../../../../responsive/ResponsiveProvider";

interface Section7Props {
  businessData: BusinessHomeProfile | null;
}

const Section7: FC<Section7Props> = ({ businessData }) => {
  const mobile = useResponsive().isMobile;

  return (
    <div
      style={{
        width: "100%",
        background: "linear-gradient(180deg, #f7fbff 0%, #eef6ff 100%)",
        padding: mobile ? "2rem 1.25rem" : "4rem 1.75rem",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1180px",
          borderRadius: "32px",
          background: "linear-gradient(135deg, rgba(15,61,99,0.96) 0%, rgba(24,93,162,0.94) 58%, rgba(247,166,74,0.92) 100%)",
          boxShadow: "0 30px 60px rgba(15, 61, 99, 0.18)",
          padding: mobile ? "2rem 1.35rem" : "3rem 3rem",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-80px",
            right: "-40px",
            width: "220px",
            height: "220px",
            borderRadius: "999px",
            background: "rgba(255,255,255,0.08)",
          }}
        />
        <div style={{ position: "relative", maxWidth: mobile ? "100%" : "760px" }}>
          <div style={{ textTransform: "uppercase", color: "rgba(255,255,255,0.84)", fontSize: "0.85rem", letterSpacing: "0.14em", marginBottom: "1rem", fontWeight: 700 }}>
            Warm, professional adult family home care
          </div>
          <div style={{ color: "#ffffff", fontSize: mobile ? "2.1rem" : "4rem", lineHeight: 1.05, fontWeight: 800, marginBottom: "1rem" }}>
            {businessData?.businessName}
          </div>
          <div style={{ color: "rgba(255,255,255,0.9)", fontSize: mobile ? "1rem" : "1.15rem", lineHeight: 1.8, maxWidth: "720px" }}>
            Personalized senior care services in {businessData?.city}, {businessData?.state}, with a welcoming home environment, clearer communication, and thoughtful day-to-day support.
          </div>
          <div className="grid mt-4" style={{ maxWidth: "720px" }}>
            <div className="col-12 md:col-4">
              <div style={{ background: "rgba(255,255,255,0.12)", borderRadius: "22px", padding: "0.95rem 1rem", border: "1px solid rgba(255,255,255,0.12)" }}>
                <div style={{ color: "rgba(255,255,255,0.72)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.1em" }}>Location</div>
                <div style={{ color: "#ffffff", fontWeight: 700, marginTop: "0.45rem" }}>{businessData?.city}, {businessData?.state}</div>
              </div>
            </div>
            <div className="col-12 md:col-4">
              <div style={{ background: "rgba(255,255,255,0.12)", borderRadius: "22px", padding: "0.95rem 1rem", border: "1px solid rgba(255,255,255,0.12)" }}>
                <div style={{ color: "rgba(255,255,255,0.72)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.1em" }}>Setting</div>
                <div style={{ color: "#ffffff", fontWeight: 700, marginTop: "0.45rem" }}>Adult family home</div>
              </div>
            </div>
            <div className="col-12 md:col-4">
              <div style={{ background: "rgba(255,255,255,0.12)", borderRadius: "22px", padding: "0.95rem 1rem", border: "1px solid rgba(255,255,255,0.12)" }}>
                <div style={{ color: "rgba(255,255,255,0.72)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.1em" }}>Experience</div>
                <div style={{ color: "#ffffff", fontWeight: 700, marginTop: "0.45rem" }}>Care-led presentation</div>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-2 mt-4">
            <span style={{ background: "rgba(255,255,255,0.14)", color: "#ffffff", borderRadius: "999px", padding: "0.65rem 0.95rem", fontWeight: 600 }}>
              Private home setting
            </span>
            <span style={{ background: "rgba(255,255,255,0.14)", color: "#ffffff", borderRadius: "999px", padding: "0.65rem 0.95rem", fontWeight: 600 }}>
              Family-friendly communication
            </span>
            <span style={{ background: "rgba(255,255,255,0.14)", color: "#ffffff", borderRadius: "999px", padding: "0.65rem 0.95rem", fontWeight: 600 }}>
              Professional care presentation
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section7;
